__turbopack_context__.v({
  "forgethead": "reset-module__tQuL0q__forgethead",
  "loginbtnforgt": "reset-module__tQuL0q__loginbtnforgt",
  "register": "reset-module__tQuL0q__register",
  "signupforget": "reset-module__tQuL0q__signupforget",
});
